import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import red from "@material-ui/core/colors/red";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import grey from "@material-ui/core/colors/grey";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottomStyle: "solid",
    borderBottomColor: grey[300],
  },

  titleRow: {
    fontWeight: "bold",
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
  },

  logoContainer: {
    marginBottom: theme.spacing(1),
  },

  logo: {
    display: "block",
    maxHeight: 45,
    maxWidth: 125,
  },

  description: {
    marginBottom: theme.spacing(2),
  },

  radioGroup: {
    marginTop: theme.spacing(2),
    minWidth: 125,
    display: "flex",
    flexDirection: "row",
  },

  radioBox: {
    maxWidth: 175,
    minWidth: 150,
    maxHeight: 75,
    borderStyle: "solid",
    borderColor: theme.palette.primary.light,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },

  radioLabel: {
    fontSize: ".85rem",
  },

  selectedRadioBox: {
    borderColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
  },

  termsButtonLabel: {
    fontWeight: "bold",
    fontSize: "1.1",
    textTransform: "uppercase",
  },

  errorRow: {
    marginTop: 30,
    fontSize: 14,
    color: red[500],
  },

  acceptDescription: {
    marginTop: theme.spacing(2),
  },

  label: {
    fontSize: ".75rem",
  },
}));

const OptIn = ({
  accepted,
  declined,
  error,
  onAccept,
  onDecline,
  onViewTerms,
  optIn,
  regionName,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      onAccept();
    } else {
      onDecline();
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.titleRow}>
        {optIn.logoUri && (
          <div className={classes.logoContainer}>
            <img className={classes.logo} src={optIn.logoUri} alt="Logo" />
          </div>
        )}
        <div>{optIn.optInTitle}</div>
      </div>

      <div className={classes.description}>{optIn.optInDescription}</div>

      {optIn.regional && regionName && (
        <div className={error ? classes.descriptionError : classes.description}>
          {t("optin_region", { regionName })}
        </div>
      )}

      <div>
        {optIn.termsUri && (
          <Button
            classes={{ label: classes.termsButtonLabel }}
            className={classes.termsButton}
            variant="text"
            color="secondary"
            onClick={onViewTerms}
          >
            {t("optin_view_terms")}
          </Button>
        )}
      </div>

      <FormControlLabel
        classes={{ label: classes.label }}
        disabled={optIn.termsUri && !accepted}
        control={
          <Checkbox
            checked={accepted}
            onChange={handleCheckboxChange}
            name={optIn.optInId}
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
          />
        }
        label={t("optin_accept")}
      />

      {error && <div className={classes.errorRow}>{error}</div>}
    </div>
  );
};

export default OptIn;
